import type { TwiageCase } from "@/App/types/TwiageCase";
import { groupBy } from "@/App/utils/groupBy";

export type GroupBy<T> = (element: T) => string;

export const groupCases = (cases: TwiageCase[], groupKey?: GroupBy<TwiageCase>): Record<string, TwiageCase[]> => {
  if (groupKey) {
    return groupBy<TwiageCase>(cases, groupKey);
  } else {
    return { cases };
  }
};
